import _ from 'lodash-es'
import moment from 'moment'
import { IAction } from '../IAction'

export class ScheduleInterview implements IAction {

    static $inject = ['$uibModal', 'interview']
    constructor(private $uibModal, private interview, private applicant: any | undefined = undefined) { }

    execute = () => {

        return this.$uibModal.open({
            templateUrl: 'areas/action/scheduleInterview/scheduleInterviewModal.html',
            controller: ScheduleInterviewModalController,
            controllerAs: 'ctrl',
            backdrop: false,
            resolve: {
                interview: () => this.interview,
                applicant: () => this.applicant
            }
        }).result
    }
}

export interface IApplicantDetails extends angular.IScope {
    applicantUserId: number
    firstName: string
    lastName: string
}

interface IScheduleInterviewModalScope extends angular.IScope {
    interviewForm: any
}

class ScheduleInterviewModalController {

    public applicants: Array<any>

    public events
    public slots

    isReschedule: boolean = false;
    applicantUser: any;
    dateStartUpdated: boolean = false;

    static $inject = ['dialogs', '$q', '$scope', '$uibModalInstance', 'Event', 'interview', 'applicant']
    constructor(
        private dialogs,
        private $q: angular.IQService,
        private $scope: IScheduleInterviewModalScope,
        private $uibModalInstance,
        private Event,
        private interview,
        private applicant
    ) {
        this.isReschedule = interview.Id && interview.Id > 0;
        
        var todayDate = moment();
        interview.todaydate = function () {
            return todayDate;
        }

        if (!interview.duration)
            interview.duration = 120;

        this.$scope.$watch(() => this.interview.dateStart, (newValue, oldValue) => {
            if (newValue && moment.isDate(newValue) && newValue != oldValue) {
                this.dateStartUpdated = true;
                if (moment(newValue).isSame(oldValue, 'day')) {
                    this.refreshResult();
                } else {
                    this.updateEvents();
                }
            }
        });

        this.$scope.$watch(() => this.interview.duration, (newValue, oldValue) => {
            this.refreshResult();
        });


        this.updateEvents();
    }

    collision() {
        return !this.checkNoCollison({
            dateStart: this.interview.dateStart,
            dateEnd: moment(this.interview.dateStart).add(this.interview.duration, 'minutes').toDate()
        })
    }

    private updateEvents() {
        var promise
        if (this.interview && this.interview.userId && this.interview.dateStart) {

            this.events = this.Event.user({
                id: this.interview.userId,
                from: moment(this.interview.dateStart).format('DD/MM/YYYY'),
                to: moment(this.interview.dateStart).add(1, 'day').format('DD/MM/YYYY')
            })
            promise = this.events.$promise
        } else {
            this.events = []
            promise = this.$q.when(this.events)
        }
        return promise.then((data) => {
            this.refreshResult()
            return data
        })
    }

    private refreshResult() {

        for (let event of this.events) {

            var before = {
                ...this.interview,
                dateStart: moment(event.dateStart).subtract(this.interview.duration, 'minutes').toDate(),
                dateEnd: event.dateStart
            }
            event.before = this.checkNoCollison(before) ? before : undefined


            var after = {
                ...this.interview,
                dateStart: event.dateEnd,
                dateEnd: moment(event.dateEnd).add(this.interview.duration, 'minutes').toDate()
            }
            event.after = this.checkNoCollison(after) ? after : undefined
        }
    }


    private checkNoCollison(newEvents) {
        if(this.isReschedule){
            this.events = _.filter(this.events, (e) => e.id !== newEvents.Id);
        }
        
        return _.every(this.events,
            (evn: any) => newEvents.dateEnd <= evn.dateStart || evn.dateEnd <= newEvents.dateStart);
    }


    selectAvalibleSlot(slot) {
        this.interview.dateStart = slot.dateStart;             
    }

    save() {
        this.$scope.$broadcast('submitted', true);

        var form = this.$scope.interviewForm;

        if (form.$dirty) {

            if(this.dateStartUpdated && this.collision()){
                this.dialogs.error('Interview Clash', 'An interview is booked for the date and time selected. Please select another slot.');
                return;
            }

            const isApplicantAttendee = this.interview?.attendingUsers.includes(this.interview.applicantUserId);

            if(!isApplicantAttendee){
                this.interview.attendingUsers.push(this.interview.applicantUserId);
            }

            let int = {
                entryId: this.interview.Id ?? 0,
                userId: this.interview.userId,
                agencyId: this.interview.agencyId,
                entryType: this.interview.entryType,
                dateStart: this.interview.dateStart,
                dateEnd: moment(this.interview.dateStart).add(this.interview.duration, 'minutes').toDate(),
                location: this.mapTypeToLocation(this.interview.entryType),
                notes: this.interview.notes,
                invitees: this.interview.attendingUsers,
                timeZoneOffsetMinutes: moment(this.interview.dateStart).toDate().getTimezoneOffset()
            };

            if(!form.$valid){
                return;
            }

            this.Event.save(int)
                .$promise.then(() => {
                    this.dialogs.notify('Scheduled Interview', 'The interview has been saved.');
                    this.$uibModalInstance.close();
                });
        }

    }

    mapTypeToLocation(type) {
        switch (type) {
            case 1:
                return 'In person';
            case 5:
                return 'Online';
            default:
                return '';
        }
    }

    close() {
        this.$uibModalInstance.dismiss()
    }

}